import { useState, type FormEvent } from "react";
import { postJson } from "../api";
import type { AgentConfig, ContextBudgetProfile, ModelOption, NovelRun } from "../types";

export function InputBudgetRecoveryPanel({ run, agents, models, contextBudget, profile, onChanged }: {
  run: NovelRun; agents: AgentConfig[]; models: ModelOption[]; contextBudget: number; profile?: ContextBudgetProfile; onChanged: () => Promise<void>
}) {
  const [role, setRole] = useState<Exclude<keyof ContextBudgetProfile, "maxInputUtilization">>("writer");
  const [budget, setBudget] = useState(profile?.writer ?? contextBudget);
  const [agentId, setAgentId] = useState("");
  const [model, setModel] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  async function recover(event: FormEvent) {
    event.preventDefault(); if (busy) return;
    setBusy(true); setError("");
    try {
      await postJson(`/api/runs/${run.id}/repair-input-budget`, {
        expectedUpdatedAt: run.updatedAt, contextBudgetProfile: { [role]: budget },
        ...(agentId && model ? { models: [{ agentId, model }] } : {})
      });
      await onChanged();
    } catch (error) { setError(error instanceof Error ? error.message : "配置恢复失败，请刷新任务状态"); }
    finally { setBusy(false); }
  }
  return <form className="panel-section" onSubmit={recover} aria-label="输入预算恢复">
    <strong>修复输入预算并继续原任务</strong>
    <p>{run.error}</p>
    <p>保留稿件、协议、声音快照和已用次数。未提交的评分、终审与账本候选凭证将失效并重新核验；历史记录保留。</p>
    <label>受阻角色资料预算<select aria-label="恢复预算角色" value={role} disabled={busy} onChange={event => { const next = event.target.value as typeof role; setRole(next); setBudget(profile?.[next] ?? contextBudget); }}>
      {Object.entries({writer:"正文写作",rewriteWriter:"正文返修",architecture:"结构规划",narrativeReviewer:"叙事评审",discourseReviewer:"篇章评审",styleReviewer:"文风评审",optimizer:"局部修订",blindReader:"独立盲读",gate:"终稿门禁",checkpoint:"批次检查",volumeAudit:"卷级检查"}).map(([id,label]) => <option key={id} value={id}>{label}</option>)}
    </select></label>
    <label>所选角色上下文预算<input aria-label="恢复上下文预算" type="number" min={1000} max={800000} step={1} value={budget} disabled={busy} onChange={event => setBudget(Number(event.target.value))} /></label>
    <label>需要更换模型的 Agent<select aria-label="恢复 Agent" value={agentId} disabled={busy} onChange={event => { setAgentId(event.target.value); setModel(""); }}>
      <option value="">保持现有模型</option>{agents.filter(agent => agent.enabled).map(agent => <option key={agent.id} value={agent.id}>{agent.name}</option>)}
    </select></label>
    {agentId && <label>新模型<select aria-label="恢复模型" value={model} required disabled={busy} onChange={event => setModel(event.target.value)}>
      <option value="">选择更合适的上下文容量</option>{models.filter(model => model.available).map(model => <option key={model.id} value={model.id}>{model.name} · {model.contextWindow} tokens</option>)}
    </select></label>}
    {error && <p role="alert">{error}</p>}
    <button className="button button-primary" disabled={busy || (Boolean(agentId) && !model)} type="submit">{busy ? "正在恢复…" : "应用配置、使旧凭证失效并继续"}</button>
  </form>;
}
